export interface Subscription<T = any> {
  unsubscribe(f: (payload: T) => void): void;
  subscribe(f: (payload: T) => void): () => void;
  emit(payload: T): void;
}

const createSubscription = <T = any>(): Subscription<T> => {
  const subscribers: Set<(payload: T) => void> = new Set();

  const unsubscribe: Subscription<T>['unsubscribe'] = (f) => {
    subscribers.delete(f);
  };

  const subscribe: Subscription<T>['subscribe'] = (f) => {
    subscribers.add(f);
    return () => unsubscribe(f);
  };

  const emit: Subscription<T>['emit'] = (payload) => {
    const snapshot = new Set(subscribers);

    snapshot.forEach((f) => {
      try {
        f(payload);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Unable to activate subscriber`, error);
      }
    });
  };

  return { unsubscribe, subscribe, emit };
};

export default createSubscription;
